import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import CKEditor from 'modules/_shared/components/CKEditor';

import { useEditIncentivesMarketTermsAndConditionsTemplateModal } from '../context/EditIncentivesMarketTermsAndConditionsTemplateModalContext';

const EditIncentivesMarketTermsAndConditionsTemplateModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } =
    useEditIncentivesMarketTermsAndConditionsTemplateModal();

  if (data.isLoading) {
    return (
      <Modal.Body className="position-relative" style={{ minHeight: 200 }}>
        <CustomLoading />
      </Modal.Body>
    );
  }

  if (data.loadError) {
    return (
      <Modal.Body>
        <p className="text-danger mb-0">
          {t('IncentivesMarketTermsTemplateLoadError')}
        </p>
      </Modal.Body>
    );
  }

  return (
    <Modal.Body>
      <div className="nk-modal">
        <p className="text-soft mb-3 fs-13px">
          {t('EditIncentivesMarketTermsAndConditionsTemplateIntro')}
        </p>

        <CKEditor
          editorInstance={data.editorInstance}
          setEditorInstance={actions.setEditorInstance}
          documentName="IncentivesMarketTermsAndConditions"
          documentModel={data.termsText}
          enableMentions={false}
          isReadOnly={false}
          onChangeContent={actions.onEditorChange}
        />
      </div>
    </Modal.Body>
  );
};

export default EditIncentivesMarketTermsAndConditionsTemplateModalBody;
